import { API, Helpers, Router } from '../Helpers';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './style.css';

export default class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            destination_loader_content: this.findDestinationLoaderContent()
        };


        console.log(props)

        this.findDestinationLoaderContent = this.findDestinationLoaderContent.bind(this);
        this.findDestinationMenu = this.findDestinationMenu.bind(this);
        this.findDestinationMenuBackground = this.findDestinationMenuBackground.bind(this);
        this.showCountries = this.showCountries.bind(this);
        this.showRegions = this.showRegions.bind(this);
    }

    componentDidMount() {
        _$('#destination-modal').on('hidden.bs.modal', (event) => {
            this.showCountries();
        });

        _$('#destination-modal').on('show.bs.modal', (event) => {
            _$('.collapse').collapse();
        });
    }

    findDestinationLoaderContent() {
        let destination_loader_content = _.find(this.props.data.active_site.settings.data, (setting) => { return setting.key == 'destination_loader_content'; });

        //console.log("destination_loader_content", destination_loader_content);

        if (!_.isEmpty(destination_loader_content)) {
            return destination_loader_content.value;
        }
    }

    findDestinationMenu() {
        let destination_menu = _.find(this.props.data.active_site.settings.data, (setting) => { return setting.key == 'destination_menu'; });

        if (!_.isEmpty(destination_menu)) {
            return destination_menu.value;
        }

        return 1;
    }

    findDestinationMenuBackground() {
        let destination_menu_background = _.find(this.props.data.active_site.settings.data, (setting) => { return setting.key == 'destination_menu_background'; });

        if (!_.isEmpty(destination_menu_background)) {
            return destination_menu_background.value;
        }
    }

    showCountries() {
        this.setState({
            regions: undefined
        });
    }

    showDestinationLoader() {
        _$('#destinationLoader').modal('show');
    }

    showRegions(regions) {
        //console.log("showRegions", regions);

        this.setState({
            regions: regions
        });
    }

    render() {

        const { active_site, csrf_token, env, locations, routes } = this.props.data;
        const router = Router(routes);

        const location_groups = _.groupBy(this.props.data.locations.data, 'country_name');
        const countries = _.keysIn(location_groups);
        const destination_menu = this.findDestinationMenu();
        const destination_loader_content = this.findDestinationLoaderContent();
        const destination_menu_background = this.findDestinationMenuBackground();


        return (
            <div>
                <div className="modal fade modal-fullscreen footer-to-bottom" id="destination-modal" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog">
                        {
                            destination_menu == 1 &&
                            <div className="modal-content background-cover three-b" style={{ backgroundColor: 'black', backgroundImage: "url(" + destination_menu_background + ")", backgroundRepeat: 'no-repeat', backgroundPosition: 'top center' }}>
                                <div className="modal-header justify-content-between align-items-center p-3">
                                    <div className={_.isEmpty(this.state.regions) ? "invisible" : ""}>
                                        <a className="font-small text-uppercase text-white" onClick={() => { this.showCountries() }}>
                                            <i className="fa fa-long-arrow-alt-left mr-2"></i>Back To All Destinations
                                        </a>
                                    </div>

                                    <div>
                                        <a className="btn-floating btn-large btn-primary d-none d-md-block m-1 text-center" data-dismiss="modal"><i className="fa fa-times"></i></a>
                                        <a className="btn-floating btn-small btn-primary d-md-none m-0 text-center" data-dismiss="modal"><i className="fa fa-times"></i></a>
                                    </div>
                                </div>
                                <div className="modal-body overflow-y-auto py-0 scroll">
                                    <div className="row">
                                        <div className="col-12 col-lg-10 mx-auto">
                                            <div className="text-center">
                                                <h3 className="body-font four-b-text font-weight-bold mb-4">Choose Your Destination</h3>

                                                {
                                                    _.isEmpty(this.state.regions) &&
                                                    <ul className="list-unstyled mb-0">
                                                        {
                                                            countries.sort().map((_country, key) => {

                                                                let locations = location_groups[_country];

                                                                return (
                                                                    <li key={key} className="py-2">
                                                                        {
                                                                            locations.length == 1 ?
                                                                                <a className="white-text" href={router.url('tours.index', { domain: active_site.domain, country_slug: locations[0].url_params.country_slug })}>
                                                                                    <h4 className="font-weight-bold mb-0">{_country}</h4>
                                                                                </a> :
                                                                                <a className="white-text" onClick={() => { this.showRegions(location_groups[_country]) }}>
                                                                                    <h4 className="font-weight-bold mb-0">{_country}</h4>
                                                                                </a>
                                                                        }
                                                                    </li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                }

                                                {
                                                    !_.isEmpty(this.state.regions) &&
                                                    <ul className="list-unstyled mb-0">
                                                        {
                                                            this.state.regions.sort().map((location, key) => {

                                                                return (
                                                                    <li key={key} className="py-2">
                                                                        <a className="white-text" href={router.url('tours.index', { domain: active_site.domain, ...location.url_params })}>
                                                                            <h4 className="font-weight-bold mb-0">{location.region}</h4>
                                                                        </a>
                                                                    </li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {
                            destination_menu == 2 &&
                            <div className="modal-content background-cover three-b" style={{ backgroundColor: 'black', backgroundImage: "url(" + destination_menu_background + ")", backgroundRepeat: 'no-repeat', backgroundPosition: 'top center' }}>
                                <div className="modal-header justify-content-end align-items-center p-3">
                                    <div>
                                        <a className="btn-floating btn-large btn-primary d-none d-md-block m-1 text-center" data-dismiss="modal"><i className="fa fa-times"></i></a>
                                        <a className="btn-floating btn-small btn-primary d-md-none m-0 text-center" data-dismiss="modal"><i className="fa fa-times"></i></a>
                                    </div>
                                </div>
                                <div className="modal-body overflow-y-auto py-0 scroll">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-12 col-lg-10 mx-auto">
                                                <div className="d-none d-lg-block">
                                                    <div className="row">
                                                        {
                                                            countries.sort().map((_country, parent_key) => {

                                                                let locations = location_groups[_country];
                                                                let country = null;

                                                                if (locations.length > 0)
                                                                    country = locations[0];


                                                                if (country)
                                                                    return (
                                                                        <div key={parent_key} className="col-3 mb-5">
                                                                            <div className="mb-2">
                                                                                <a href={router.url('tours.index', { domain: active_site.domain, country_slug: country.country_slug })}><span className="font-large font-weight-bold text-white">{country.country_name}</span></a>
                                                                            </div>

                                                                            {
                                                                                locations.length == 1 ?
                                                                                    <ul className="list-unstyled mb-0">
                                                                                        <li className="primary-text">
                                                                                            <a
                                                                                                className="primary-text"
                                                                                                href={router.url('tours.index', { domain: active_site.domain, country_slug: country.country_slug })}
                                                                                                onClick={this.showDestinationLoader}>
                                                                                                All {country.country_name} Tours
                                                                                            </a>
                                                                                        </li>
                                                                                    </ul> :
                                                                                    <ul className="list-unstyled mb-0">
                                                                                        {
                                                                                            _.orderBy(locations, ['region'], ['asc']).map((location, child_key) => {

                                                                                                return (
                                                                                                    <li key={child_key}>
                                                                                                        <a
                                                                                                            className="primary-text"
                                                                                                            href={router.url('tours.index', { domain: active_site.domain, ...location.url_params })}
                                                                                                            onClick={this.showDestinationLoader}>
                                                                                                            {location.region}
                                                                                                        </a>
                                                                                                    </li>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </ul>
                                                                            }
                                                                        </div>
                                                                    )
                                                            })
                                                        }
                                                    </div>
                                                </div>

                                                <div className="d-lg-none">
                                                    <div className="accordion" id="accordionDestinations">
                                                        {
                                                            countries.sort().map((_country, parent_key) => {

                                                                let locations = location_groups[_country];


                                                                let country = null;

                                                                if (locations.length > 0)
                                                                    country = locations[0];


                                                                if (country)
                                                                    return (
                                                                        <div key={parent_key} className="card z-depth-0 bg-transparent">
                                                                            <div className="card-header p-0">
                                                                                <h4 className="mb-0 body-font">
                                                                                    <button className="btn btn-flat btn-block" type="button" data-toggle="collapse" data-target={"#collapse" + parent_key} aria-expanded="true">
                                                                                        <span className="font-largest text-white">{country.country_name}</span>
                                                                                    </button>
                                                                                </h4>
                                                                            </div>

                                                                            <div id={"collapse" + parent_key} className="collapse show" data-parent="#accordionDestinations">
                                                                                <div className="card-body pt-0">
                                                                                    {
                                                                                        locations.length == 1 ?
                                                                                            <div className="text-center">
                                                                                                <a
                                                                                                    className="primary-text"
                                                                                                    href={router.url('tours.index', { domain: active_site.domain, country_slug: country.country_slug })}
                                                                                                    onClick={this.showDestinationLoader}>
                                                                                                    All {country.country_name} Tours
                                                                                                </a>
                                                                                            </div> :
                                                                                            <div className="text-center">
                                                                                                {
                                                                                                    _.orderBy(locations, ['region'], ['asc']).map((location, child_key) => {

                                                                                                        return (
                                                                                                            <div key={child_key} className="py-2">
                                                                                                                <a
                                                                                                                    key={child_key}
                                                                                                                    className="primary-text"
                                                                                                                    href={router.url('tours.index', { domain: active_site.domain, ...location.url_params })}
                                                                                                                    onClick={this.showDestinationLoader}>
                                                                                                                    {location.region}
                                                                                                                </a>
                                                                                                            </div>
                                                                                                        )
                                                                                                    })
                                                                                                }
                                                                                            </div>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>


                <div id="destinationLoader" className="modal modal-fullscreen three-b z-max">
                    <div className="modal-dialog p-0">
                        <div className="modal-content three-b">
                            {
                                !_.isEmpty(destination_loader_content) &&
                                <div className="modal-body p-0">
                                    <div className="progress md-progress primary-color z-3 mb-0">
                                        <div className="indeterminate"></div>
                                    </div>

                                    <div className="container-fluid pt-15">
                                        <div className="container">
                                            <div dangerouslySetInnerHTML={{ __html: destination_loader_content }}></div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

if (document.getElementById('destinationMenu')) {

    const element = document.getElementById('destinationMenu');
    const data = Object.assign({}, element.dataset);

    ReactDOM.render(<App data={JSON.parse(data.data)} />, document.getElementById('destinationMenu'));
}



// WEBPACK FOOTER //
// ./resources/js/components/DestinationMenu/App.js